
import { useEffect, useState } from "react";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import { BiDetail } from 'react-icons/bi'
import SectionWrapper from "components/wrappers/SectionWrapper";
import Language from "components/Language";
import PropTypes from 'prop-types';

const FaqDetails = ({ disabled, data }) => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])


    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${disabled ? 'bg-gray-200 text-gray-400' : ' text-blue-500 focus:ring-blue-200 hover:bg-blue-200'}`}
                onClick={() => setIsOpen(true)}>
                <BiDetail />
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
            >
                <div className="w-[480px]  lg:w-[720px]">

                    {/* Question */}
                    <SectionWrapper
                        title={t('form.question')}
                    >
                        <div className="border-2 border-dashed p-2 rounded">


                            <div className="flex items-baseline my-2 ">
                                <Language _key="fr" showKeyOnly />
                                {data?.question.french}
                            </div>

                            <div className="flex items-baseline my-2 ">
                                <Language _key="ar" showKeyOnly />
                                {data?.question.arabic}
                            </div>


                            <div className="flex items-baseline my-2 ">
                                <Language _key="en" showKeyOnly />
                                {data?.question.english}
                            </div>

                        </div>
                    </SectionWrapper>


                    {/* Response */}
                    <SectionWrapper
                        title={t('form.response')}
                    >
                        <div className="border-2 border-dashed p-2 rounded">


                            <div className="flex items-baseline my-2 ">
                                <Language _key="fr" showKeyOnly />
                                <div className="mx-2">    {data?.response?.french}</div>
                            </div>

                            <div className="flex items-baseline my-2 ">
                                <Language _key="ar" showKeyOnly />
                                <div className="mx-2">  {data?.response?.arabic}</div>
                            </div>


                            <div className="flex  items-baseline my-2 ">
                                <Language _key="en" showKeyOnly />
                                <div className="mx-2">   {data?.response?.english}</div>
                            </div>

                        </div>
                    </SectionWrapper>

                </div>

            </ModalWrapper>


        </>

    );

}

export default FaqDetails;

FaqDetails.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.object,
};

